import React from 'react';
// Context
import { authContext } from '../context/Auth';
/**
 *
 */
export default function useAuth() {
  return React.useContext(authContext);
}
